module.exports = __webpack_public_path__ + "static/media/nc.631b7461.svg";